interface IUploadedFile {
	title: string;
	contents: string;
}

enum ImportStatuses {
	PENDING = "pending",
	PROCESSING = "processing",
	COMPLETED = "completed",
	FAILED = "failed",
	PARTIALLY_FAILED = "partially_failed"
}

interface IImport {
	id: string;
	title?: string;
	timestampStart: number;
	timestampEnd: number;
	failedIDs?: number[];
	status: ImportStatuses;
	messages: string[];
	initiator: string;
}

export { IUploadedFile, IImport, ImportStatuses };
